import React from "react";
import AppointmentOverviewList from "./src/appointmentOverviewList";
import SearchControlls from "./src/searchControls";
import LoadingMessage from "./src/loadingMessage";
import Section from "../../components/section/section";
import BookAppointmentDialog from "./src/bookAppointmentDialog";
import { AppointmentOverviewContext } from "./context/appointmentOverviewContext";
import Appointment from "./interface/appointment";

const AppointmentOverviewContainer = (): React.JSX.Element => {
  const {
    bookingAppointment,
  }: { bookingAppointment: Appointment | null } = React.useContext(
    AppointmentOverviewContext,
  );

  return (
    <Section>
      <SearchControlls />
      <LoadingMessage />
      <AppointmentOverviewList />
      {/* mounted only while a booking is in progress, so the dialog starts with an empty search */}
      {bookingAppointment && <BookAppointmentDialog />}
    </Section>
  );
};

export default AppointmentOverviewContainer;
